import { ChevronLeft, ChevronRight, X } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import { Pressable } from "react-native";
import { styled, Text, View, XStack, YStack } from "tamagui";
import { Body } from "../ui/Body";
import { Box } from "../ui/Box";
import { Subtext } from "../ui/Subtext";
import { type HelperManager, HelpItemRequiredType } from "./HelperManager";

const _PressableStyled = styled(Pressable);

export const HelperUI = observer(({ manager }: { manager: HelperManager }) => {
  const currentItem = manager.currentItem;

  if (!currentItem) {
    return null;
  }

  let extraLabel = "";
  if (currentItem.type === HelpItemRequiredType.Tip) {
    extraLabel = "Tip!";
  } else if (currentItem.isCompleted()) {
    extraLabel = "Done";
  } else if (currentItem.type === HelpItemRequiredType.Required) {
    extraLabel = "Next";
  }

  return (
    <Box>
      <YStack gap="$space.small" position="relative">
        <View position="absolute" top={-6}>
          <Subtext fontSize={10} fontWeight={"600"} letterSpacing={1.1}>
            GUIDES
          </Subtext>
        </View>
        <View
          cursor="pointer"
          position="absolute"
          top={0}
          right={0}
          zIndex={1}
          onPress={() => {
            manager.dismiss();
          }}
          testID={"guide-hide"}
        >
          <X />
        </View>
        <XStack gap="$space.medium" alignItems="center">
          <Text lineHeight={32} fontSize={32}>
            {currentItem.type === HelpItemRequiredType.Required ? "👋" : "💡"}
          </Text>
          <YStack gap="$space.small" flex={1}>
            <XStack gap="$space.small" alignItems="center">
              <View
                cursor="pointer"
                onPress={() => manager.gotoPrevStep()}
                padding={1}
              >
                <ChevronLeft
                  color={manager.isFirstStep ? "$muted" : undefined}
                />
              </View>
              {manager.icons.map(({ icon, isCurrent }, i) => {
                const Icon = icon;
                return (
                  <View
                    borderRadius={1000}
                    cursor="pointer"
                    onPress={() => manager.gotoStep(i)}
                    key={`icon_${i}`}
                    backgroundColor={
                      isCurrent && !manager.isComplete
                        ? "$color.primary"
                        : undefined
                    }
                    padding={5}
                  >
                    <Icon size={"$small"} />
                  </View>
                );
              })}

              <View
                cursor="pointer"
                onPress={() => manager.gotoNextStep()}
                padding={1}
              >
                <ChevronRight
                  color={manager.isLastStep ? "$muted" : undefined}
                />
              </View>
            </XStack>
            <XStack gap="$space.small">
              <Body
                textDecorationLine={
                  currentItem.isCompleted() &&
                  currentItem.type !== HelpItemRequiredType.Tip
                    ? "line-through"
                    : undefined
                }
              >
                {!!extraLabel && <Body muted>{extraLabel} </Body>}
                {currentItem.label}
              </Body>
            </XStack>
          </YStack>
        </XStack>
      </YStack>
    </Box>
  );
});
